import { render } from "./Orders.vue?vue&type=template&id=7ee0e360&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=7ee0e360&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ee0e360"

export default script